let appName = ''

export function getAppName() {
  return appName
}

export function initAppName() {
  if (!appName) appName = document.title
}
